import axios from "axios";
import { SHAIA_API, SHAIA_PYTHON_API } from "../utils/constans";
import * as Sentry from "@sentry/react";

const client = axios.create({
  baseURL: SHAIA_API,
  headers: {
    accept: "application/json",
    "Content-Type": "application/json",
  },
  timeout: 10000000,
});

export const pythonClient = axios.create({
  baseURL: SHAIA_PYTHON_API,
  headers: {
    accept: "application/json",
    "Content-Type": "application/json",
  },
  timeout: 10000000,
});

// Interceptor para reportar errores de respuesta
const responseErrorInterceptor = (error) => {
  // Reporta el error a Sentry
  Sentry.captureException(error);
  // Propaga el error para que pueda ser manejado por otros catch o bloques de error
  return Promise.reject(error);
};
client.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

client.interceptors.response.use(
  (response) => response,
  responseErrorInterceptor
);
pythonClient.interceptors.response.use(
  (response) => response,
  responseErrorInterceptor
);

export default client;
